export default {
	id: "iphone-5c",
	title: "iPhone 5c",
	company: "Apple",
	// borderRadius: "0.1em",
	colorSide: true,
	styles: [
		{
			title: "normal",
			pos: ["14.6%", "7.5%", "14.8%", "8.5%"],
			colors: [
				{
					title: "White",
					hex: "#ffffff",
					img: require("./original/white.png")
				},
				{title: "Blue", hex: "#2FA3EB", img: require("./original/blue.png")},
				{
					title: "Green",
					hex: "#7DC051",
					img: require("./original/green.png")
				},
				{title: "Red", hex: "#F05455", img: require("./original/red.png")},
				{
					title: "Yellow",
					hex: "#E7D533",
					img: require("./original/yellow.png")
				}
			]
		}
	]
};
